import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import Toasted from 'vue-toasted'
Vue.use(Toasted, { type: 'success', position: 'bottom-center', duration: 5000 })

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

// https://github.com/FortAwesome/vue-fontawesome
// https://fontawesome.com/icons?d=gallery
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBars,
  faTimes,
  faSearch,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faSquare,
  faCheckSquare,
  faCheck,
  faCircle,
  faCheckCircle,
  faPlus,
  faCalendarDay,
  faUser,
  faTally,
  faArrowRight,
  faEnvelope,
  faSpinner,
  faMortarPestle,
  faCalendarWeek,
  faUserGraduate,
  faTag,
  faListOl,
  faCogs,
  faWrench,
  faBold,
  faLink,
  faTrash,
  faArrowDown,
  faChevronLeft,
  faMapMarker,
  faPhone,
  faClock,
  faPlusCircle,
  faMinusCircle,
  faBell,
  faBells,
  faTable,
  faFolderTree,
  faFileExcel,
  faEdit,
  faArrowSquareRight,
  faUserPlus,
  faUserMinus,
  faUserFriends,
  faUserSlash,
  faPowerOff,
  faToggleOn,
  faToggleOff} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faBars,
  faTimes,
  faSearch,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faSquare,
  faCheckSquare,
  faCheck,
  faCircle,
  faCheckCircle,
  faPlus,
  faCalendarDay,
  faUser,
  faTally,
  faArrowRight,
  faEnvelope,
  faSpinner,
  faMortarPestle,
  faCalendarWeek,
  faUserGraduate,
  faTag,
  faListOl,
  faCogs,
  faWrench,
  faBold,
  faLink,
  faTrash,
  faArrowDown,
  faChevronLeft,
  faMapMarker,
  faPhone,
  faClock,
  faPlusCircle,
  faMinusCircle,
  faEnvelope,
  faBell,
  faBells,
  faTable,
  faFolderTree,
  faFileExcel,
  faEdit,
  faArrowSquareRight,
  faUserPlus,
  faUserMinus,
  faUserFriends,
  faUserSlash,
  faPowerOff,
  faToggleOn,
  faToggleOff,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import Layout from '@/components/Layout'
import StepList from '@/components/StepList'
import StepItem from '@/components/StepItem'
import DataTable from '@/components/DataTable'
import SearchInput from '@/components/SearchInput'
import MessageForm from '@/components/MessageForm'
import Checkbox from '@/components/Checkbox'
// import ImageInput from '@/components/ImageInput'
import YesNo from '@/components/YesNo'
import Modal from '@/components/Modal'
import Panel from '@/components/Panel'
import DatePicker from '@/components/DatePicker'
import IconRouterLink from '@/components/IconRouterLink'
import Collapse from '@/components/Collapse'
import Workflow from '@/components/Workflow/Workflow'
import WorkflowStep from '@/components/Workflow/WorkflowStep'
import WorkflowTask from '@/components/Workflow/WorkflowTask'
import FilterInput from '@/components/FilterInput'
import TitleSlot from '@/components/TitleSlot'
import DisplayWishList from '@/components/DisplayWishList'

Vue.component('layout', Layout)
Vue.component('step-list', StepList)
Vue.component('step-item', StepItem)
Vue.component('data-table', DataTable)
Vue.component('search-input', SearchInput)
Vue.component('message-form', MessageForm)
Vue.component('checkbox', Checkbox)
// Vue.component('image-input', ImageInput)
Vue.component('yes-no', YesNo)
Vue.component('modal', Modal)
Vue.component('panel', Panel)
Vue.component('date-picker', DatePicker)
Vue.component('icon-router-link', IconRouterLink)
Vue.component('collapse', Collapse)
Vue.component('workflow', Workflow)
Vue.component('workflow-step', WorkflowStep)
Vue.component('workflow-task', WorkflowTask)
Vue.component('filter-input', FilterInput)
Vue.component('title-slot', TitleSlot)
Vue.component('display-wish-list', DisplayWishList)

require('string.prototype.endswith')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
